import { Controller } from "@hotwired/stimulus"

// Pokazuje/ukrywa pola źródła w formularzu listy mailingowej zależnie od typu listy.
// Pole "tag" ma sens tylko dla kind == "tag", pole "segment" tylko dla kind == "filter".
// Initial state ustawia ERB klasą "hidden", JS przejmuje stan przy zmianie selecta.
export default class extends Controller {
  static targets = ["kindSelect", "tagField", "filterField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const kind = this.kindSelectTarget.value
    if (this.hasTagFieldTarget) {
      this.tagFieldTarget.classList.toggle("hidden", kind !== "tag")
    }
    if (this.hasFilterFieldTarget) {
      this.filterFieldTarget.classList.toggle("hidden", kind !== "filter")
    }
  }
}
